import { Box, Divider, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

import { Editor } from '@tiptap/core';

import { editorClasses } from '../../classes';
import { ToolbarItem } from './ToolbarItem';
import { ToolbarGroups } from './config';
import { ToolbarItemType, ToolbarOptions } from './types';
import { dividerSx } from './styles';

const boxStyles: SxProps<Theme> = {
  gap: 0.5,
  display: 'flex',
};

type Props = {
  boxType: ToolbarOptions.Align | ToolbarOptions.List | ToolbarOptions.TextStyle;
  toolbarConfig: ToolbarOptions[];
  editor: Editor;
  toolbarItems: { [key: string]: ToolbarItemType },
};

const ToolbarBox: FC<Props> = ({ boxType, toolbarConfig, editor, toolbarItems }) => {
  const options = toolbarConfig.includes(boxType)
    ? ToolbarGroups[boxType]
    : ToolbarGroups[boxType].filter((boxOption) => toolbarConfig.includes(boxOption));
  if (!options.length) return undefined;

  return (
    <>
      <Divider orientation="vertical" flexItem sx={dividerSx} />
      <Box sx={{ ...boxStyles }}>
        {options.map((option) => {
          const optionConfig = toolbarItems[option];
          return (
            <ToolbarItem
              key={option}
              aria-label={optionConfig.label}
              active={editor.isActive(option)}
              className={editorClasses.toolbar[option as keyof typeof editorClasses.toolbar]}
              onClick={optionConfig.onClick}
              icon={<path d={optionConfig.icon} />}
            />
          );
        })}
      </Box>
    </>
  );
};

export default ToolbarBox;
